//# sourceMappingURL=feature_flags.mjs.map
/// <reference types="./feature_flags.d.mts" />
import * as $organization from "../../../data_types/data/auth/organization.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $skeleton from "../../../ds/ds/components/skeleton.mjs";
import * as $toggler from "../../../ds/ds/components/toggler.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import * as $html from "../../../sketch_redraw/sketch/redraw/dom/hooks/html.mjs";
import * as $org_effects from "../../admin/effects/organization.mjs";
import * as $card from "../../components/card.mjs";
import * as $store from "../../data/store.mjs";
import { toList, isEqual } from "../../gleam.mjs";

function ff_loader() {
  return $l.column(
    toList([$l.gap(24)]),
    toList([]),
    (() => {
      let _pipe = $organization.all_feature_flags;
      return $list.map(
        _pipe,
        (_) => { return $skeleton.custom($length.px(300), $length.px(20)); },
      );
    })(),
  );
}

function on_toggle(organization, set_organization, dispatch) {
  return (flag, present) => {
    let _block;
    if (present) {
      let _pipe = organization.feature_flags;
      _block = $list.prepend(_pipe, flag);
    } else {
      let _pipe = organization.feature_flags;
      _block = $list.filter(_pipe, (ff) => { return !isEqual(flag, ff); });
    }
    let feature_flags = _block;
    set_organization(
      new Some(
        new $organization.Organization(
          organization.id,
          organization.name,
          organization.display_name,
          feature_flags,
          organization.enabled,
        ),
      ),
    );
    let _pipe = feature_flags;
    let _pipe$1 = ((_capture) => {
      return $org_effects.update_feature_flags(organization.id, _capture);
    })(_pipe);
    dispatch(_pipe$1);
    return undefined;
  };
}

function present(organization, flag) {
  let _pipe = organization.feature_flags;
  let _pipe$1 = $list.find(_pipe, (f) => { return isEqual(f, flag); });
  return $result.is_ok(_pipe$1);
}

function toggle_feature_flag() {
  return $redraw.component_(
    "Feature_flag",
    (_use0) => {
      let feature_flag = _use0[0];
      let present$1 = _use0[1];
      let toggle_feature_flag$1 = _use0[2];
      let toggle_feature_flag$2 = (present) => {
        return toggle_feature_flag$1(feature_flag, present);
      };
      return $l.row(
        toList([$l.gap(24)]),
        toList([]),
        toList([
          $l.column(
            toList([$l.styles(toList([$css.width($length.px(200))]))]),
            toList([]),
            toList([
              $html.text(
                (() => {
                  let _pipe = feature_flag;
                  let _pipe$1 = $organization.feature_flag_to_string(_pipe);
                  return $string.capitalise(_pipe$1);
                })(),
              ),
            ]),
          ),
          $l.column(
            toList([]),
            toList([]),
            toList([
              $toggler.toggler(
                toList([
                  $toggler.active(present$1),
                  $toggler.on_change(toggle_feature_flag$2),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

function toggle_list() {
  return $redraw.compose(
    toggle_feature_flag(),
    (toggle_feature_flag) => {
      return $redraw.component_(
        "FeatureFlagToggleList",
        (_use0) => {
          let organization = _use0[0];
          let set_organization = _use0[1];
          let dispatch = $store.use_effect_dispatch();
          return $l.column(
            toList([$l.gap(12)]),
            toList([]),
            (() => {
              let _pipe = $organization.all_feature_flags;
              return $list.map(
                _pipe,
                (ff) => {
                  return toggle_feature_flag(
                    [
                      ff,
                      present(organization, ff),
                      on_toggle(organization, set_organization, dispatch),
                    ],
                  );
                },
              );
            })(),
          );
        },
      );
    },
  );
}

export function view() {
  return $redraw.compose(
    toggle_list(),
    (toggle_list) => {
      return $redraw.component_(
        "Feature_flags",
        (_) => {
          let store = $store.use_state();
          let $ = $redraw.use_state(new None());
          let organization = $[0];
          let set_organizations = $[1];
          $redraw.use_effect(
            () => {
              let $1 = store.organization;
              let $2 = store.organizations;
              if ($1 instanceof Some && $2 instanceof $remote.Loaded) {
                let organization$1 = $1[0];
                let organizations = $2[0][1];
                let _pipe = organizations;
                let _pipe$1 = $list.find(
                  _pipe,
                  (o) => { return o.id === organization$1; },
                );
                let _pipe$2 = $option.from_result(_pipe$1);
                return set_organizations(_pipe$2);
              } else {
                return undefined;
              }
            },
            [store.organization, store.organizations],
          );
          return $card.card(
            toList([]),
            toList([
              $l.column(
                toList([$l.gap(24)]),
                toList([]),
                toList([
                  $card.title(toList([]), toList([$html.text("Feature flags")])),
                  (() => {
                    if (organization instanceof Some) {
                      let organization$1 = organization[0];
                      return toggle_list([organization$1, set_organizations]);
                    } else {
                      return ff_loader();
                    }
                  })(),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}
